import HttpClient from "../helpers/HttpClient"
import { HttpError, isError } from "../helpers/Error"
import Group, { GroupDto } from "./Group"

class PricingTableGroupService {
    static httpClient: HttpClient<Group, GroupDto> = new HttpClient<Group, GroupDto>(Group)

    static async updateGroup(
        id: string,
        mainObjectId: string,
        documentType: string,
        payload: { name: string, description: string, calendarEventIds: string[] | [] }
    ): Promise<Group | HttpError> {
        const res = await this.httpClient.patch(`/${documentType}/${mainObjectId}/groups/${id}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Group
    }

    static async deleteGroup(id: string, documentType: string, mainObjectId: string) {
        return this.httpClient.delete(`/${documentType}/${mainObjectId}/groups/${id}`)
    }

}

export default PricingTableGroupService


// WEBPACK FOOTER //
// ./src/state/pricing/PricingTableGroupService.ts